export default __webpack_public_path__ + "static/media/Dividend_Distribution_Policy_2.6c2dd93d.pdf";